module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/MoneymanGirl-610b263e829724c202044755104766bb.png";